<template>
    <div>
    <div class="wrap" v-if="line.text_sizes.length ==0">
        <label class="inline">{{line.title}}</label>
        <div class="wrapping">
            <em :class="[{red:line.textIsCut},'hint']">{{this.$store.getters.strings.subnoteText}}</em>
        </div>
    </div>
    <div class="wrap" v-if="line.text_sizes.length">
        <div class="box" v-bind:style="setStyleLine">
        <label >{{line.title}}</label>
            <input @click="deletePlaceHolder" class="cmpt" type="text" v-model="someValue" @keyup="onInput" @blur="onInput" @keydown="onInput" :placeholder="line.placeholder" />
            <em  v-show="parseInt(line.max_chars)!= 99999" :class="[{red:line.textIsCut},'hint']">{{this.$store.getters.strings.subnoteText}} {{parseInt(line.max_chars)-someValue.length}}</em>
        </div>
          <div v-if="line.text_sizes.length" v-show="parseInt(line.allow_fontsize)" class="box add-style-select">
             <label>{{this.$store.getters.strings.textSize}}</label>
                <select class="cmpt" @change="changeFontSize($event)">
                    <option  v-for="size in line.text_sizes" v-bind:value="size.value" v-bind:selected="checkFontSizeSelected(size)">{{size.title}}</option>
                </select>
            </div>
    </div>
    </div>

</template>
<script>

    export default {
        data(){
            return {
                someValue : this.removeEmojis(this.line.text.replace('<','')),
                dummy : true
            }
        },
        props   : ['line', 'label'],
        mounted : function() {
            window.addEventListener( 'updateLine', this.updateLine )
        },
        methods : {
            updateLine(){
                this.someValue = this.line.text;
            },
            removeEmojis (string) {
                var regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|[\ud83c[\ude50\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
                var value=string.replace(regex, '');
                if(typeof (this.label.format_functions) !="undefined"){
                    if(typeof (this.label.format_functions[this.line.block_name.toLowerCase()]) !="undefined"){
                       var fn = window[this.label.format_functions[this.line.block_name.toLowerCase()]];
                        if ( typeof fn === 'function' ) {
                            value= fn(value);
                        }
                    }
                }
                return value;
            },
            onInput ( e ) {
                const value = e.target.value;
                    this.someValue = value;
                this.$store.dispatch('setMasterText', {labelId: this.label.id});
            },
            checkLabelRegex ( string, before ) {
                if ( this.label.template_label_regex !== null ) {
                    if ( this.label.template_label_regex.length > 0 && string.length > 0 ) {
                        var label_regex = new RegExp( '^' + this.label.template_label_regex + '+$', "gm" );
                        if ( ! label_regex.test( this.someValue ) ) {
                            return before;
                        } else {
                            return string;
                        }
                    } else {
                        return string;
                    }
                } else {
                    return string;
                }
            },
            copy ( o ) {
                var output, v, key;
                output = Array.isArray( o ) ? [] : {};
                for ( key in o ) {
                    v = o[key];
                    output[key] = (typeof v === "object") ? this.copy( v ) : v;
                }
                return output;
            },
            changeFontSize (event){
                $jQuery( ".previewMessage" + this.label.uniqueId ).hide();
                this.line.font_size_default = parseFloat($jQuery( event.target ).val());
                this.$store.dispatch( 'setMasterText', {labelId : this.label.id} );
                this.dummy =!this.dummy;
            },
            checkFontSizeSelected (size) {
                console.log(this.dummy);
                if(parseFloat(this.line.fontsize)>=size.selected.min && parseFloat(this.line.fontsize)<=size.selected.max )
                     return true;
                return false;
            },
            deletePlaceHolder (){
                $jQuery( ".previewMessage"+this.label.uniqueId  ).hide();
                this.line.placeholder = "";
                  this.$store.dispatch( 'setMasterText', {labelId : this.label.id} );

            }

        },
        computed   : {
            setStyleLine () {
                if ( parseInt(this.line.allow_fontsize) ) {
                    return {
                        'width' : '60.9%'
                    }
                }
                return {
                    'width' :'100%'
                }
            }
        },
        watch : {
            someValue : {
                handler : function( after, before ) {

                  this.someValue=this.removeEmojis(this.someValue.replace('<',''));
                  this.someValue=this.checkLabelRegex(this.someValue, before);

                    this.line.text = this.someValue;
                    this.$store.dispatch( 'setMasterText', {labelId : this.label.id} );
                    const record = this.$store.getters.labels.find( element => element.id == this.label.id );
                    if ( record ) {
                         if(this.someValue.length > parseInt( this.line.max_chars)){
                             this.someValue = before;
                             return;
                         }
                         if(this.someValue.length > parseInt(record.max_chars)){
                             this.someValue = before;
                             return;
                         }
                        if ( this.line['fontsize'] < this.line.min_font_size && before.length < after.length) {
                            this.someValue = before;
                        }
                       if(typeof(fontsConfig[this.label.code])!="undefined"){
                            if(typeof (fontsConfig[this.label.code][this.line.font]) != "undefined"){
                                const min = parseFloat( fontsConfig[this.label.code][this.line.font]['min']);
                                const max = parseFloat( fontsConfig[this.label.code][this.line.font]['max']);
                                if ( this.line['fontsize'] < min && before.length < after.length ) {
                                    this.someValue = before;
                                }
                                if ( this.line['fontsize'] > max && before.length < after.length ) {
                                    this.someValue = before;
                                }
                            }
                        }
                    }
                },
                deep    : true
            }
        },
        updated: function(){
            //this.someValue = this.line.text;
        },
        getters : {}
    }
</script>
<style>
    .lineContainer .input_line {
        border-radius    : 10px;
        background-color : #FFFFFF;
        border           : solid 2px #005380;
        margin-top       : 10px;
        float:left;
    }

    .lineComponent {
        height  : 100px;
        float   : left;
        display : inline-block;
        width   : 100%;
    }
    .textSizesContainer select{
         width:90%;
    }

    .line_title {
        height      : 20px;
        font-family : 'SourceSansPro';
        font-size   : 16px;
        color       : #005380;
        width:100%;
        float:left;
    }

    .textSizesContainer {
        width: 25%;
        text-align: center;
        float: left;
        display: inline-block;
          margin: 10px 0px 0px 0px;
    }

    .lineContainer .line {
        float : left;
        width:100%;
        display: inline-block;
    }

    .subNote {
        height         : 24px;
        font-family    : SourceSansPro-It;
        font-size      : 13px;
        font-weight    : normal;
        font-style     : normal;
        font-stretch   : normal;
        line-height    : 1.85;
        letter-spacing : normal;
        text-align     : left;
        color          : #009DE0;
    }
    .red{
        color:red;
    }

</style>



// WEBPACK FOOTER //
// src/components/Line.vue